import LoginLayout from '@src/layout/LoginLayout';
import {
  CustomButton,
  CustomForm,
  CustomFormItem,
  CustomNumberInput, errorDialog,
  Text,
  useText,
  warningDialog,
} from '@src/components';
import React, { useCallback, useEffect } from 'react';
import '@src/styles/login/smsVerification.scss';
import { useDispatch, useSelector } from 'react-redux';
import { loginOtp, migrationOtp, reSendOtpSms, setMigrationId } from '@src/store/slice/authSlice';
import { useTimer } from 'react-timer-hook';
import { counterFormat } from '@src/utils/utils';
import { Popover } from 'antd';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';

let didMount = true;

const SmsVerification = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { mobileLoginId, msisdn, token, MigrationId } = useSelector((state) => state?.auth);
  const time = new Date();
  const deadline = time.setMinutes(time.getMinutes() + 2);
  const counter = useTimer({ autoStart: false, expiryTimestamp: deadline });

  useEffect(async () => {
    const searchParam = new URLSearchParams(history.location.search);
    const migrationId = searchParam.get('MigrationId')?.replace(/ /g, '+');
    if (migrationId) {
      dispatch(setMigrationId(migrationId));
      const MigrationData = await dispatch(migrationOtp({ migrationId }));
      if (migrationOtp.fulfilled.match(MigrationData)) {
        counter.restart(new Date().setMinutes(new Date().getMinutes() + 2));
      }
      if (migrationOtp.rejected.match(MigrationData)) {
        errorDialog({
          title: <Text t="error" />,
          message: 'Bir hata oluştu.',
        });
      }
    } else {
      dispatch(setMigrationId(null));
    }
  }, [history]);

  useEffect(() => {
    if (token) {
      history.push('/dashboard');
    }
  }, [history, token]);

  const handleSendSmsAgain = useCallback(async () => {
    if (counter.minutes === 0 && counter.seconds === 0) {
      const action = await dispatch(reSendOtpSms());
      if (reSendOtpSms.fulfilled.match(action)) {
        counter.restart(new Date().setMinutes(new Date().getMinutes() + 2));
      } else {
        counter.pause();
      }
    }
  }, [counter, dispatch, counter.seconds]);

  useEffect(() => {
    if (MigrationId || mobileLoginId) {
      counter.start();
    }
    return () => {
      counter.pause();
    };
  }, []);

  const onFinish = useCallback(
    async (values) => {
      if (values?.otp.toString().length === 6) {
        const body = {
          otp: parseFloat(values?.otp),
          ...(MigrationId && { migrationId: MigrationId })
        };
        const action = await dispatch(loginOtp(body));
        if (loginOtp?.fulfilled?.match(action)) {
          if (action?.payload?.data?.hasNoCustomerVous) {
            errorDialog({
              title: <Text t="error" />,
              htmlContent: <Text t="dearCustomerYouCannotLogInToYour" />,
              onOk: () => {
                history.push('/login');
              },
            });
          } else {
            counter.pause();
            history.push('/dashboard');
          }
        } else {
          warningDialog({
            title: <Text t="warning" />,
            htmlContent: <Text t="mustBe6Char" />,
          });
        }
      } else {
        warningDialog({
          title: <Text t="warning" />,
          htmlContent: <Text t="mustBe6Char" />,
        });
      }
    },
    [counter, dispatch, history, MigrationId],
  );

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <LoginLayout isBackButton={!MigrationId} className={'smsVerification'}>
        <div className="rightSideLoginFormTitle">
          <Text t="smsVerification" />
        </div>
        <p className="labelExplanation">
          <Text t="enterVerificationCode" />
        </p>

        <label className="labelPhone">
          <Text t="yourPhoneNumber" /> <span className="phoneValue">{msisdn}</span>
        </label>

        <CustomForm name="smsVerification" initialValues={{}} onFinish={onFinish} layout={'vertical'}>
          <CustomFormItem name="otp" rules={[{ required: true, message: <Text t="checkSMS" /> }]}>
            <CustomNumberInput
              id="smsVerification-main-otp-numberInput"
              autoComplete="off"
              placeholder={useText('enterDigitVerifCode')}
              maxLength={6}
            />
          </CustomFormItem>

          <label className="labelRemainingTime">
            <Text t="remainingTime" />
            <span className="time">{counterFormat(counter)}</span>
            {(() => {
              const sendAgainButton = (
                <button type="button" className="sendAgain" onClick={() => handleSendSmsAgain()}>
                  <Text t="sendSmsAgain" />
                </button>
              );
              const isCounterEnded = counter.minutes === 0 && counter.seconds === 0;
              return isCounterEnded ? sendAgainButton : (
                <Popover
                  content={<Text t="waitForSmsCounterReset" />}
                  placement="right"
                  trigger="click"
                  overlayClassName="sms-tooltip"
                >
                  {sendAgainButton}
                </Popover>
              );
            })()}
          </label>

          <CustomFormItem>
            <CustomButton id="smsVerification-login-primary-btn" type="primary" htmlType="submit" style={{ width: '100%' }}>
              <span className="submit">
                <Text t="loginBtn" />
              </span>
            </CustomButton>
          </CustomFormItem>
        </CustomForm>
      </LoginLayout>
    </>
  );
};

export default SmsVerification;
